var React = require('react');

function IconMapSettingsSystemPoisActive (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M14.466 22.299l3.235 3.231L8 32l6.466-9.701zM24.836 7l6.27 6.268h-.002L33 15.165l-1.97 1.966-1.893-1.893-3.61 3.61-1.71 10.6-13.265-13.265 10.6-1.71 3.61-3.61L22.87 8.97 24.835 7z"})),React.createElement("use",{"fill":"#30B4C0","xlinkHref":"#a","key":1})]);
}

IconMapSettingsSystemPoisActive.defaultProps = {"width":"40","height":"40"};

module.exports = IconMapSettingsSystemPoisActive;

IconMapSettingsSystemPoisActive.default = IconMapSettingsSystemPoisActive;
